<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const emit = defineEmits(['close']);
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[720px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <KitIcon
            class="tw-w-[88px]"
            state="success"
          />

          <ModalHeader>
            <ModalHeading>Discount Applied!</ModalHeading>

            <ModalSubText>
              Great news! Your 50% discount has been successfully applied to your account. You'll enjoy this discount for the next 3 months, and your subscription will continue as normal after this period.
            </ModalSubText>

            <ModalSubText>
              Thank you for staying with us!
            </ModalSubText>
          </ModalHeader>
        </KitModalHeader>

        <div class="tw-flex tw-items-center tw-gap-4 tw-self-end">
          <DefaultButton
            @click="emit('close')"
          >
            Continue to Dashboard
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>

